export const AUTH_HEADER_KEY = 'auth_header'
export const NEW_AUTH_HEADER_KEY = 'auth_header_info'
interface HeaderAndOrgId {
  header: string
  orgID: number
}
interface HeaderAndOptionalOrgId {
  header: string
  orgID: number | null // Maybe one day this can be made non-nullable
}

export function loadAuthHeader(): HeaderAndOptionalOrgId | null {
  const header = localStorage.getItem(NEW_AUTH_HEADER_KEY)
  if (!header) {
    // Backwards compatibility with old storage format
    const oldHeader = localStorage.getItem(AUTH_HEADER_KEY)
    if (oldHeader) {
      return {
        header: oldHeader,
        orgID: null,
      }
    } else {
      return null
    }
  }
  return JSON.parse(header)
}

export function saveAuthHeader(header: HeaderAndOrgId | undefined) {
  if (header) {
    localStorage.setItem(NEW_AUTH_HEADER_KEY, JSON.stringify(header))
  } else {
    localStorage.removeItem(NEW_AUTH_HEADER_KEY)
  }
}
